import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from "session";
import * as actions from '../action';
import * as c from '../constant';

function NewFixedFeesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  newFixedFeesId,
  getSingleNewFixedFees,
  newFixedFeesInfo,
  ordinanceRevisionId,
}) {
  useEffect(() => {
    if (_.isEmpty(newFixedFeesId)) return;
    getSingleNewFixedFees(newFixedFeesId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(newFixedFeesId)) return;
    getSingleNewFixedFees(newFixedFeesId);
  }, [newFixedFeesId]);

  const authProfile = getJson('profile') || {};
  const [token, setToken] = useState("");
  const permissions = getJson('permissions');

  const srcDownload = `${process.env.REACT_APP_WS}api/v1/bpls/administrator/report/fixed_fees/generate_pdf?bearer_token=${token}
  &email=${_.get(
    authProfile,
    "email"
  )}&ordinance_revision_id=${ordinanceRevisionId}`;

  useEffect(() => {
    const getToken = get("token") || "";
    setToken(getToken);
  }, []);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
            >
              Add Fixed Fee &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
            {Acl(permissions, ['E2E BPLS TAX REVENUE GENERATE PDF']) && (
              <a
                className="btn btn-primary cms-bg-color-primary cms-outline-primary     ml-1"
                href={srcDownload}
                target="_blank"
                without="true"
                rel="noopener noreferrer"
              >
                <i className="fas fa-print" /> Generate PDF
              </a>
            )}
          </div>
        </div>
        {!_.isEmpty(newFixedFeesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(newFixedFeesInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(newFixedFeesInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(newFixedFeesInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(newFixedFeesInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Code
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(newFixedFeesInfo, 'attributes.code')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(newFixedFeesInfo, 'attributes.name')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Description
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newFixedFeesInfo, 'attributes.description')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Multiplier
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newFixedFeesInfo, 'attributes.multiplier')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Amount
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newFixedFeesInfo, 'attributes.amount_human')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          For New
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {' '}
                            {_.get(newFixedFeesInfo, 'attributes.for_new')
                              ? 'Yes'
                              : 'No'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          For Renewal
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {' '}
                            {_.get(newFixedFeesInfo, 'attributes.for_renewal')
                              ? 'Yes'
                              : 'No'}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

NewFixedFeesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  newFixedFeesInfo: PropTypes.instanceOf(Object).isRequired,
  newFixedFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  newFixedFeesInfo: _.get(api, `${c.GET_SINGLE_NEW_FIXED_FEES}.item`) || {},
  newFixedFeesId: _.get(match, 'params.newFixedFeesId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewFixedFeesContent);
